import React from 'react';

const AutomationList = () => {
  return (
    <svg width="147" height="89" viewBox="0 0 147 89" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.9998 73L47.9077 58.1189C56.0719 53.4295 56.0886 45.8043 47.9451 41.103V41.103C39.8412 36.4246 39.8125 28.8446 47.8809 24.1458L54.9997 20"
        stroke="#E6E9EC"
      />
      <path
        d="M17.9998 75L47.9796 57.9796C56.1301 53.3524 69.3154 53.44 77.3985 58.1064V58.1064C85.4881 62.7765 98.6863 62.8599 106.834 58.2237L112.5 55"
        stroke="#E6E9EC"
      />
      <circle r="13.0035" transform="matrix(0.866044 -0.499967 0.866044 0.499967 60.8391 49.0714)" fill="#6D61FF" />
      <g clipPath="url(#clip0_3995_110132)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60.9196 53.7617L69.0443 49.0713L60.9196 44.3809L52.7949 49.0713L60.9196 53.7617ZM67.8039 49.0713L60.9196 53.0456L57.7878 51.2376L64.6721 47.2633L67.8039 49.0713ZM64.0518 46.9052L57.1676 50.8795L54.0354 49.0713L60.9196 45.097L64.0518 46.9052ZM58.7506 48.5712L58.7366 48.5792L57.0823 48.0224L56.5752 48.3152L57.5397 49.2702L57.5268 49.2776L55.8857 48.7132L55.3208 49.0393L57.9559 49.9293L58.5476 49.5877L57.5766 48.6252L57.5898 48.6176L59.257 49.1782L59.8577 48.8314L58.3165 47.3099L57.7729 47.6238L58.7506 48.5712ZM65.0309 50.0219L63.4065 49.0842L62.6906 49.4975L62.2266 49.2296L64.2286 48.0739L64.6926 48.3417L63.9665 48.7608L65.5909 49.6986L65.0309 50.0219Z"
          fill="white"
        />
      </g>
      <circle r="2.87354" transform="matrix(0.866044 -0.499967 0.866044 0.499967 38.404 63.6202)" fill="#4E40EF" />
      <g filter="url(#filter0_d_3995_110132)">
        <rect
          width="28.7354"
          height="28.7354"
          rx="6"
          transform="matrix(0.866044 -0.499967 0.866044 0.499967 0.999512 70.847)"
          fill="white"
        />
        <rect
          x="0.519033"
          width="28.1361"
          height="28.1361"
          rx="5.70034"
          transform="matrix(0.866044 -0.499967 0.866044 0.499967 1.06904 71.1065)"
          stroke="#E6E9EC"
          strokeWidth="0.599315"
        />
      </g>
      <rect
        width="9.40431"
        height="2.08985"
        rx="1.04492"
        transform="matrix(0.866044 -0.499967 0.866044 0.499967 8.99316 70.5858)"
        fill="#E6E9EC"
      />
      <rect
        x="0.866044"
        width="17.6345"
        height="12.2357"
        rx="3.5"
        transform="matrix(0.866044 -0.499967 0.866044 0.499967 13.9358 73.8051)"
        fill="white"
        stroke="#E6E9EC"
      />
      <path
        d="M30.012 73.3051L29.987 73.1289L29.7281 73.1412L29.7069 73.2906L30.012 73.3051ZM25.1409 70.493L25.166 70.6692L25.4248 70.6569L25.4461 70.5075L25.1409 70.493ZM29.7069 73.2906C29.6273 73.85 29.2159 74.3974 28.4723 74.8266L28.9053 75.0766C29.755 74.5861 30.2261 73.9595 30.3172 73.3196L29.7069 73.2906ZM28.4723 74.8266C26.8132 75.7844 24.1334 75.7879 22.4868 74.8373L22.0538 75.0873C23.9419 76.1773 27.0094 76.1711 28.9053 75.0766L28.4723 74.8266ZM22.4868 74.8373C20.8403 73.8867 20.8462 72.3397 22.5053 71.3819L22.0723 71.1319C20.1764 72.2264 20.1657 73.9973 22.0538 75.0873L22.4868 74.8373ZM22.5053 71.3819C23.2489 70.9526 24.1971 70.7151 25.166 70.6692L25.1158 70.3168C24.0074 70.3694 22.922 70.6414 22.0723 71.1319L22.5053 71.3819ZM25.4461 70.5075C25.5257 69.9481 25.9371 69.4007 26.6807 68.9715L26.2476 68.7215C25.3979 69.212 24.9268 69.8386 24.8357 70.4785L25.4461 70.5075ZM26.6807 68.9715C28.3398 68.0136 31.0196 68.0102 32.6661 68.9608L33.0992 68.7108C31.2111 67.6208 28.1436 67.627 26.2476 68.7215L26.6807 68.9715ZM32.6661 68.9608C34.3127 69.9114 34.3068 71.4584 32.6476 72.4162L33.0807 72.6662C34.9766 71.5717 34.9872 69.8008 33.0992 68.7108L32.6661 68.9608ZM32.6476 72.4162C31.9041 72.8455 30.9559 73.083 29.987 73.1289L30.0371 73.4813C31.1456 73.4287 32.231 73.1567 33.0807 72.6662L32.6476 72.4162Z"
        fill="#E6E9EC"
      />
      <path
        d="M30.012 73.3051L29.7069 73.2906L29.6773 73.4983L30.0371 73.4813L30.012 73.3051ZM25.1409 70.493L24.8357 70.4785L24.8062 70.6862L25.166 70.6692L25.1409 70.493ZM28.4908 71.3712C29.3995 71.8959 29.8049 72.6016 29.7069 73.2906L30.3172 73.3196C30.4293 72.5319 29.9656 71.7227 28.9238 71.1212L28.4908 71.3712ZM25.166 70.6692C26.3595 70.6126 27.582 70.8466 28.4908 71.3712L28.9238 71.1212C27.882 70.5198 26.4802 70.2521 25.1158 70.3168L25.166 70.6692ZM25.4461 70.5075C25.5257 69.9481 25.9371 69.4007 26.6806 68.9715L26.2476 68.7215C25.3979 69.212 24.9268 69.8386 24.8357 70.4785L25.4461 70.5075ZM26.6806 68.9715C28.3398 68.0137 31.0196 68.0102 32.6661 68.9608L33.0991 68.7108C31.2111 67.6208 28.1435 67.627 26.2476 68.7215L26.6806 68.9715ZM32.6661 68.9608C34.3127 69.9114 34.3068 71.4584 32.6476 72.4162L33.0807 72.6662C34.9766 71.5717 34.9872 69.8008 33.0991 68.7108L32.6661 68.9608ZM32.6476 72.4162C31.9041 72.8455 30.9559 73.083 29.987 73.1289L30.0371 73.4813C31.1456 73.4287 32.231 73.1567 33.0807 72.6662L32.6476 72.4162Z"
        fill="#E6E9EC"
      />
      <circle r="2.87354" transform="matrix(0.866044 -0.499967 0.866044 0.499967 49.9313 22.6808)" fill="#4E40EF" />
      <g filter="url(#filter1_d_3995_110132)">
        <rect
          width="28.7354"
          height="28.7354"
          rx="6"
          transform="matrix(0.866044 -0.499967 0.866044 0.499967 37.7144 15.3668)"
          fill="white"
        />
        <rect
          x="0.519033"
          width="28.1361"
          height="28.1361"
          rx="5.70034"
          transform="matrix(0.866044 -0.499967 0.866044 0.499967 37.7839 15.6263)"
          stroke="#E6E9EC"
          strokeWidth="0.599315"
        />
      </g>
      <rect
        width="9.40431"
        height="2.08985"
        rx="1.04492"
        transform="matrix(0.866044 -0.499967 0.866044 0.499967 51.2886 16.9341)"
        fill="#E6E9EC"
      />
      <rect
        width="17.7637"
        height="5.22462"
        rx="2.61231"
        transform="matrix(0.866044 -0.499967 0.866044 0.499967 55.3608 19.2851)"
        fill="#E6E9EC"
      />
      <circle r="2.87354" transform="matrix(0.866044 -0.499967 0.866044 0.499967 109.206 56.8998)" fill="#4E40EF" />
      <g filter="url(#filter2_d_3995_110132)">
        <rect
          width="28.7354"
          height="28.7354"
          rx="6"
          transform="matrix(0.866044 -0.499967 0.866044 0.499967 96.9888 49.5858)"
          fill="white"
        />
        <rect
          x="0.519033"
          width="28.1361"
          height="28.1361"
          rx="5.70034"
          transform="matrix(0.866044 -0.499967 0.866044 0.499967 97.0583 49.8453)"
          stroke="#E6E9EC"
          strokeWidth="0.599315"
        />
      </g>
      <rect
        width="9.40431"
        height="2.08985"
        rx="1.04492"
        transform="matrix(0.866044 -0.499967 0.866044 0.499967 110.563 51.1531)"
        fill="#E6E9EC"
      />
      <rect
        width="17.7637"
        height="5.22462"
        rx="2.61231"
        transform="matrix(0.866044 -0.499967 0.866044 0.499967 114.635 53.5041)"
        fill="#E6E9EC"
      />
      <defs>
        <filter
          id="filter0_d_3995_110132"
          x="-0.751064"
          y="55.8402"
          width="53.2736"
          height="34.808"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.39726" />
          <feGaussianBlur stdDeviation="2.39726" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3995_110132" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3995_110132" result="shape" />
        </filter>
        <filter
          id="filter1_d_3995_110132"
          x="35.9638"
          y="0.360064"
          width="53.2736"
          height="34.808"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.39726" />
          <feGaussianBlur stdDeviation="2.39726" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3995_110132" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3995_110132" result="shape" />
        </filter>
        <filter
          id="filter2_d_3995_110132"
          x="95.2382"
          y="34.5791"
          width="53.2736"
          height="34.808"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.39726" />
          <feGaussianBlur stdDeviation="2.39726" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3995_110132" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3995_110132" result="shape" />
        </filter>
        <clipPath id="clip0_3995_110132">
          <rect
            width="9.40431"
            height="9.40431"
            fill="white"
            transform="matrix(0.866044 -0.499967 0.866044 0.499967 52.7949 49.0713)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AutomationList;
